/* Face check — camera guard.  (added 2026-09-18)

   THE REPORT
   "In some phones camera features is not working it stucks as starting camera."

   WHY IT IS A SEPARATE FILE
   Everything else that bolts onto the scan lives in assets/face-check-page.js,
   a 21KB file with five heavily documented sections. Reproducing all of it to
   append a sixth is a transcription risk with no upside — one mistyped
   character in the parts that already work would break the parts that already
   work. This file is loaded next to it and touches nothing it owns.

   TWO FAILURES WEAR THE SAME FACE
   "Starting the camera" is shown from the moment I'M READY is tapped until the
   first frame is measured. Both of these look identical from the outside:

     THE CAMERA NEVER OPENED. getUserMedia was refused or never resolved. The
     big one for this shop is the IN-APP BROWSER: essentially all paid traffic
     arrives from Instagram and Facebook ads, which open links inside their own
     webview. On iOS that webview will not hand over the camera at all, and on
     Android it frequently has no camera permission of its own. So the single
     most common visitor to this page is the one most likely to be stuck —
     which is why the warning below is shown BEFORE they tap, not after.

     THE CAMERA OPENED BUT THE MODEL DID NOT ARRIVE. MediaPipe is several
     megabytes from a CDN. On a slow or filtered connection the face is sitting
     there live on screen while nothing measures it. The engine's own timeout
     is forty seconds and then blames the lighting, which is both wrong and too
     late.

   The two need different advice, so the watchdog asks the video element which
   one happened rather than guessing.

   TWENTY SECONDS
   face-check-page.js already says 'Please wait' at three seconds, which covers
   an ordinary model load. Twenty is past the point where that explanation has
   stopped being true, and still well inside the engine's forty-second timeout,
   so the honest message arrives before the misleading one.

   It defers to the engine: if the real scan starts, or the engine's own
   trouble panel appears, this removes itself and says nothing. */
(function(){
  var stage = document.getElementById('bt-stage');
  var start = document.getElementById('bt-start');
  if(!stage || !start) return;

  var step  = document.getElementById('bt-step');
  var video = document.getElementById('bt-video');

  var UA     = navigator.userAgent || '';
  var IN_APP = /Instagram|FBAN|FBAV|FB_IAB|FBIOS|Snapchat|Line\/|Pinterest|Twitter/i.test(UA);
  var IOS    = /iPad|iPhone|iPod/i.test(UA);

  var WATCH_MS = 20000;

  try{
    var st = document.createElement('style');
    st.textContent =
      '.bt-camwarn{margin:14px 0 0;padding:11px 13px;border-radius:4px;' +
        'background:#FDF3E7;border:1px solid rgba(169,82,42,.28);' +
        'font-size:13px;line-height:1.5;color:#14100D;text-align:left}' +
      '.bt-camwarn b{display:block;margin-bottom:3px;font-size:13.5px}' +
      '.bt-camfail{margin:16px 0 0;padding:14px;border-radius:4px;' +
        'background:#FBF9F6;border:1px solid rgba(20,16,13,.16);text-align:left}' +
      '.bt-camfail b{display:block;font-size:15px;margin-bottom:6px}' +
      '.bt-camfail p{margin:0 0 10px;font-size:13px;line-height:1.5;' +
        'color:rgba(20,16,13,.75)}' +
      '.bt-camfail a{display:inline-block;margin-right:16px;font-size:13px;' +
        'text-decoration:underline;text-underline-offset:3px;color:#A9522A}';
    document.head.appendChild(st);
  }catch(e){}

  function el(tag, cls, text){
    var n = document.createElement(tag);
    if(cls)  n.className = cls;
    if(text) n.textContent = text;
    return n;
  }

  /* ---- a) Warn the in-app browser BEFORE the tap ----
     After the tap there is nothing useful to say: the camera is already
     refused and the only advice is to start over somewhere else. */
  if(IN_APP){
    try{
      var w = el('div', 'bt-camwarn');
      w.appendChild(el('b', '', 'Open this in your browser first'));
      w.appendChild(document.createTextNode(IOS
        ? 'You are in the Instagram or Facebook browser, and it will not let the camera start. Tap the … menu at the top right, choose Open in Safari, and the scan will work.'
        : 'You are in the Instagram or Facebook browser, which usually blocks the camera. Tap the ⋮ menu at the top right, choose Open in Chrome, and the scan will work.'));
      start.parentNode.insertBefore(w, start.nextSibling);
    }catch(e){}
  }

  /* ---- b) Watchdog ---- */
  var timer = null, finished = false, panel = null;

  function visible(n){
    return !!(n && n.style.display && n.style.display !== 'none');
  }

  /* A live picture means the camera half succeeded, whatever else did not. */
  function gotPicture(){
    return !!(video && video.srcObject && video.readyState >= 2 && video.videoWidth > 0);
  }

  function standDown(){
    finished = true;
    if(timer){ clearTimeout(timer); timer = null; }
    if(panel) panel.style.display = 'none';
  }

  function giveUp(){
    timer = null;
    if(finished || visible(step)) return;

    var picture = gotPicture();

    try{
      panel = el('div', 'bt-camfail');
      panel.setAttribute('role', 'status');

      panel.appendChild(el('b', '', picture
        ? 'The face reader is taking too long'
        : 'The camera did not start'));

      panel.appendChild(el('p', '', picture
        ? 'Your camera is working — the part that reads the face has not finished downloading. That is almost always a slow or restricted connection. Try again on wi-fi, or skip it and use the size guide.'
        : (IN_APP
            ? 'This is the Instagram or Facebook browser and it is blocking the camera. Open theblanktag.in in Chrome or Safari and the scan will work.'
            : 'The camera did not open. Check that this site is allowed to use your camera in the browser settings, and that no other app has the camera open.')));

      var guide = el('a', '', 'Use the size guide instead');
      guide.href = '/pages/size-guide';

      var shop = el('a', '', 'Browse the frames');
      shop.href = '/collections/women';

      panel.appendChild(guide);
      panel.appendChild(shop);
      stage.appendChild(panel);
    }catch(e){}
  }

  if(!('MutationObserver' in window)) return;

  /* The engine hides I'M READY the moment it starts opening the camera. */
  new MutationObserver(function(){
    if(start.style.display === 'none' && !timer && !finished){
      timer = setTimeout(giveUp, WATCH_MS);
    }
  }).observe(start, { attributes:true, attributeFilter:['style'] });

  if(step){
    new MutationObserver(function(){
      if(visible(step)) standDown();
    }).observe(step, { attributes:true, attributeFilter:['style'] });
  }

  var trouble = document.getElementById('bt-trouble');
  if(trouble){
    new MutationObserver(function(){
      if(visible(trouble)) standDown();
    }).observe(trouble, { attributes:true, attributeFilter:['style'] });
  }
})();
